"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PageLevelMessageState = /** @class */ (function () {
    function PageLevelMessageState() {
    }
    return PageLevelMessageState;
}());
exports.default = PageLevelMessageState;
//# sourceMappingURL=PageLevelMessageState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/PageLevelMessage/PageLevelMessageState.js
// module id = 1668
// module chunks = 8